import * as types from './mutation-types'

export default {
  [types.ADD_LOADING_MESSAGES] (state, message) {
    state.messagesLoading.splice(0)
    state.messagesLoading.push(message)
  },
  [types.DEL_LOADING_MESSAGES] (state, message) {
    state.messagesLoading.splice(0)
  },
  [types.ADD_TOAST] (state, toast) {
    state.toasts.push(toast)
  },
  [types.DEL_TOAST] (state, toast) {
    let index = state.toasts.indexOf(toast)
    state.toasts.splice(index, 1)
  },
  [types.SET_CAPTCHA_KEY] (state, key) {
    state.captchaPublicKey = key
  }
}
